import * as Effects from 'redux-saga/effects'
import { IRoomWasUpdated } from '../../actions/bookingCalendar/room/requestUpdateRoom'
import requestPrices from '../../actions/price/requestPrices'
import { RoomActions } from '../../reducers/bookingCalendar/actionNames'

function* updateRoomPrices(action: IRoomWasUpdated) {
  yield Effects.put(requestPrices([+action.room.id]))
}

export default function* () {
  yield Effects.takeEvery(RoomActions.RoomWasUpdated, updateRoomPrices)
}
